import React, { useCallback, useEffect, useState } from "react";
import T from "prop-types";
import { get, isEmpty, sum } from "lodash";
import api from "APP_ROOT/api";
import { COST, QTY, TIER_TYPE_WARNING_LIMITS } from "APP_ROOT/constants";
import { dollars } from "LIB/formatters/currency";
import { NON_QUALIFIER, TIER_TYPES_MAP } from "../../parts/constants";
import Warning from "../../shared/components/Warning/Warning";
import useCurrentUser from "../../../hooks/useCurrentUser";

export default function TierTypeWarning({
  cost,
  part,
  quantity = 0,
  initialQuantity = 0
}) {
  if (!part) {
    return null;
  }

  if (isEmpty(cost) && isEmpty(quantity)) return null;

  const user = useCurrentUser();
  const [sellableQty, setSellableQty] = useState(0);
  const [tierTypeLimits, setTierTypeLimits] = useState();

  const getValue = useCallback((tierType, field) =>
    get(tierTypeLimits.filter(t => t.tier === tierType), `[0].${field}`)
  );

  useEffect(
    () => {
      api.appSetting.index().then(({ data }) => {
        setTierTypeLimits(get(data, TIER_TYPE_WARNING_LIMITS));
      });
    },
    [part.id]
  );

  useEffect(
    () => {
      api.parts.sellableQuantities(part.id).then(({ data }) => {
        setSellableQty(sum(Object.values(data)));
      });
    },
    [part.id]
  );

  if (!tierTypeLimits) return null;

  const action = user.high_confidence_buyer
    ? "Please reevaluate purchase"
    : "Manager Approval is required";

  const tier = part.tier_type || NON_QUALIFIER;
  const showQtyWarning =
    !isEmpty(quantity) &&
    getValue(tier, QTY) &&
    sellableQty + parseFloat(quantity) - parseFloat(initialQuantity) >
      Number(getValue(tier, QTY));

  const showCostWarning =
    !isEmpty(cost) &&
    getValue(tier, COST) &&
    cost > Number(getValue(tier, COST));

  if (showCostWarning || showQtyWarning) {
    return (
      <React.Fragment>
        {showQtyWarning && (
          <Warning>
            {TIER_TYPES_MAP[tier]} Warning: This would potentially put us at or
            over a sellable quantity of {getValue(tier, QTY)} units in stock.{" "}
            {action}.
          </Warning>
        )}
        {showCostWarning && (
          <Warning>
            Warning: You are purchasing this at or above cost of{" "}
            {dollars(getValue(tier, COST))}. {action}.
          </Warning>
        )}
      </React.Fragment>
    );
  }

  return null;
}

TierTypeWarning.propTypes = {
  cost: T.number,
  initialQuantity: T.string,
  part: T.shape({}),
  quantity: T.string
};



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/shared/TierTypePurchaseWarning.jsx